export type StreamTerminalStatus = 'COMPLETED' | 'FAILED' | 'CANCELLED'

export class FailedStreamTerminalError extends Error {
  constructor() {
    super('Assistant response failed')
    this.name = 'FailedStreamTerminalError'
  }
}

export function getStreamTerminalStatus(data: string): StreamTerminalStatus | undefined {
  try {
    const terminal: unknown = JSON.parse(data)
    if (terminal && typeof terminal === 'object' && 'status' in terminal) {
      if (terminal.status === 'COMPLETED' || terminal.status === 'FAILED' || terminal.status === 'CANCELLED') {
        return terminal.status
      }
    }
  } catch {
    return undefined
  }
  return undefined
}
